import { CompanyStatusEnumMap, useGetCompanies } from '@services/companies'
import { TreeSelect, TreeSelectProps } from '@shared/innmaxUI'
import { includes, isNil } from 'ramda'
import React from 'react'

export default function CompaniesTreeSelect({
  status,
  onChange,
  showAll = false,
  allSession,
  ...props
}: TreeSelectProps & {
  status?: keyof typeof CompanyStatusEnumMap
  showAll?: boolean
  allSession?: boolean
}) {
  const { dataSource } = useGetCompanies()

  const handleChange = React.useCallback(
    (value: number[], labelList: any, extra: any) => {
      if (includes(-1, value)) {
        onChange && onChange([-1], labelList, extra)
      } else {
        onChange && onChange(value, labelList, extra)
      }
    },
    [onChange]
  )

  const _treeData = React.useMemo(() => {
    if (!dataSource?.content) {
      return []
    }

    const convertToTreeData = (company: any): any => {
      return {
        title: company.name,
        value: company.id,
        children: company.sessions?.map(convertToTreeData) || [],
      }
    }

    const _data = dataSource.content
      .filter(x => (!isNil(status) ? x.status === status : true))
      .map(convertToTreeData)

    if (showAll) {
      _data.unshift({
        title: '全部',
        value: -1,
        children: [],
      })
    }

    return _data
  }, [dataSource, showAll, status])

  return (
    <TreeSelect
      showSearch
      multiple
      treeData={_treeData}
      onChange={handleChange}
      {...props}
    />
  )
}
